import useFetch from '../../../hooks/useFetch';
import { useState } from 'react';
import { EndPoints } from '../EndPoints';
import { PurchaseDocumentDataForm, PurchaseDocumentFilters } from '../../models/PurchaseDocument';
import { ServiceEvents } from '../shared/interfaces';

const usePurchaseDocumentService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetPurchaseDocuments, setFetchingGetPurchaseDocuments] = useState(false);
    const [fetchingShowPurchaseDocument, setFetchingShowPurchaseDocument] = useState(false);
    const [fetchingStorePurchaseDocument, setFetchingStorePurchaseDocument] = useState(false);
    const [fetchingStoreNote, setFetchingStoreNote] = useState(false);
    const [fetchingEditPurchaseDocument, setFetchingEditPurchaseDocument] = useState(false);
    const [fetchingCreatePurchaseDocument, setFetchingCreatePurchaseDocument] = useState(false);
    const [fetchingCreateNote, setFetchingCreateNote] = useState(false);
    const [fetchingUpdatePurchaseDocument, setFetchingUpdatePurchaseDocument] = useState(false);
    const [fetchingDeletePurchaseDocument, setFetchingDeletePurchaseDocument] = useState(false);
    const [fetchingActivePurchaseDocument, setFetchingActivePurchaseDocument] = useState(false);
    const [fetchingGetPurchaseDocument, setFetchingGetPurchaseDocument] = useState(false);
    const [fetchingDraftPurchaseDocument, setFetchingDraftPurchaseDocument] = useState(false);
    const [fetchingAnulledPurchaseDocument, setFetchingAnulledPurchaseDocument] = useState(false);
    const [fetchingAccountedPurchaseDocument, setFetchingAccountedPurchaseDocument] = useState(false);
    const [fetchingGetPurchaseDocumentDetails, setFetchingGetPurchaseDocumentDetails] = useState(false);
    const [fetchingGetCauseNote, setFetchingGetCauseNote] = useState(false);
    const [fetchingUpdateNote, setFetchingUpdateNote] = useState(false);
    const [fetchingCalculateTotalNote, setFetchingCalculateTotalNote] = useState(false);
    const [fetchingGetServiceManifestsByClientSociety, setFetchingGetServiceManifestsByClientSociety] = useState(false);
    
    const getPurchaseDocuments = (filters: PurchaseDocumentFilters,  events: ServiceEvents = {}) => {
        const queryString = Object.entries(filters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        const url = `${EndPoints.PURCHASE_DOCUMENT.GET_PURCHASE_DOCUMENT}?${queryString}`;
        doGet({
            ...events,
            url: url,
            setFetching: setFetchingGetPurchaseDocuments
        });
    };

    const showPurchaseDocument = (id: number,  events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.PURCHASE_DOCUMENT.SHOW_PURCHASE_DOCUMENT.replace(':id', id.toString()),
            setFetching: setFetchingShowPurchaseDocument
        });
    };

    const storePurchaseDocument = (taxDocument: PurchaseDocumentDataForm,  events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.PURCHASE_DOCUMENT.STORE_PURCHASE_INVOICE,
            body: taxDocument,
            setFetching: setFetchingStorePurchaseDocument
        });
    };

    // const storeNote = (taxDocument: PurchaseDocumentDataForm,  events: ServiceEvents = {}) => {
    //     doPost({
    //         ...events,
    //         url: EndPoints.PURCHASE_DOCUMENT.STORE_NOTE,
    //         body: taxDocument,
    //         setFetching: setFetchingStoreNote
    //     });
    // };

    const editPurchaseDocument = (id: number,  events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.PURCHASE_DOCUMENT.EDIT_PURCHASE_DOCUMENT.replace(':id', id.toString()),
            setFetching: setFetchingEditPurchaseDocument
        });
    };

    // const createPurchaseDocument = ( events: ServiceEvents = {}) => {
    //     doGet({
    //         ...events,
    //         url: EndPoints.CREDIT_NOTE.CREATE_CREDIT_NOTE,
    //         setFetching: setFetchingCreatePurchaseDocument
    //     });
    // };

    const createPurchaseDocument = ( events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.PURCHASE_DOCUMENT.CREATE_PURCHASE_INVOICE,
            setFetching: setFetchingCreatePurchaseDocument
        });
    };

    // const createNote = ( events: ServiceEvents = {}) => {
    //     doGet({
    //         ...events,
    //         url: EndPoints.PURCHASE_DOCUMENT.CREATE_NOTE,
    //         setFetching: setFetchingCreateNote
    //     });
    // };

    const updatePurchaseDocument = (
        id: number,
        taxDocument: PurchaseDocumentDataForm,
        events: ServiceEvents = {},
        isFolioAndDateOnly: boolean
    ) => {
        doPut({
            ...events,
            url: EndPoints.PURCHASE_DOCUMENT.UPDATE_PURCHASE_INVOICE.replace(':id', id.toString()),
            body: { ...taxDocument, isFolioAndDateOnly },
            setFetching: setFetchingUpdatePurchaseDocument
        });
    };

    // const updateNote = (
    //     id: number,
    //     taxDocument: PurchaseDocumentDataForm,
    //     events: ServiceEvents = {},
    //     isFolioAndDateOnly: boolean  // Se agrega este parámetro opcional
    // ) => {
    //     doPut({
    //         ...events,
    //         url: EndPoints.PURCHASE_DOCUMENT.UPDATE_NOTE.replace(':id', id.toString()),
    //         body: { ...taxDocument, isFolioAndDateOnly }, // Agregar `isFolioAndDateOnly` al cuerpo de la solicitud
    //         setFetching: setFetchingUpdateNote
    //     });
    // };

    const deletePurchaseDocument = (id: number,  events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.PURCHASE_DOCUMENT.DELETE_PURCHASE_DOCUMENT.replace(':id', id.toString()),
            setFetching: setFetchingDeletePurchaseDocument
        });
    };

    const activePurchaseDocument = (id: number, active: boolean,  events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.PURCHASE_DOCUMENT.ACTIVE_PURCHASE_DOCUMENT.replace(':id', id.toString()),
            body: { active: active },
            setFetching: setFetchingActivePurchaseDocument
        });
    };

    // const getPurchaseDocument = (id: number,  events: ServiceEvents = {}) => {
    //     doGet({
    //         ...events,
    //         url: EndPoints.PURCHASE_DOCUMENT.GET_PURCHASE_DOCUMENT.replace(':id', id.toString()),
    //         setFetching: setFetchingGetPurchaseDocument
    //     });
    // };

    // const getCauseNote = (noteType: string, events: ServiceEvents = {}) => {
    //     doGet({
    //         ...events,
    //         url: EndPoints.PURCHASE_DOCUMENT.GET_CAUSE_NOTE.replace(':note_type', noteType),
    //         setFetching: setFetchingGetCauseNote
    //     });
    // };

    // const taxDocumentDraft = (id: number, events: ServiceEvents = {}) => {
    //     doPut({
    //         ...events,
    //         url: EndPoints.PURCHASE_DOCUMENT.DRAFT.replace(':id', id.toString()),
    //         setFetching: setFetchingDraftPurchaseDocument
    //     });
    // };

    const purchaseDocumentAccounted = (id: number, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.PURCHASE_DOCUMENT.ACCOUNTED.replace(':id', id.toString()),
            setFetching: setFetchingAccountedPurchaseDocument
        });
    };

    // const taxDocumentAnnulled = (id: number, data: { reason: string }, events: ServiceEvents = {}) => {
    //     // Hacemos un PUT enviando la razón de anulación en el cuerpo de la solicitud
    //     doPut({
    //         ...events,
    //         url: EndPoints.PURCHASE_DOCUMENT.ANNULLED.replace(':id', id.toString()),
    //         body: data,  // Enviamos el objeto completo
    //         setFetching: setFetchingAnulledPurchaseDocument
    //     });
    // };

    const getPurchaseDocumentDetails = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.PURCHASE_DOCUMENT_DETAIL.GET_PURCHASE_DOCUMENT_DETAILS.replace(':id', id.toString()),
            setFetching: setFetchingGetPurchaseDocumentDetails,
        });
    };

    const getServiceManifestsByClientSociety = (societyId: number, providerId: number, events: ServiceEvents = {}) => {
        const url = `${EndPoints.SERVICE_MANIFEST.GET_SERVICE_MANIFESTS_BY_PROVIDER_SOCIETY.replace(':society_id', societyId.toString()).replace(':provider_id', providerId.toString())}`;

        doGet({
            ...events,
            url: url,
            setFetching: setFetchingGetServiceManifestsByClientSociety
        });
    };

    // const calculateTotalNote = (taxDocument: { total_unit: number, cant: number, taxes: any[] }, events: ServiceEvents = {}) => {
    //     doPost({
    //         ...events,
    //         url: EndPoints.PURCHASE_DOCUMENT.CALCULATE_TOTAL_NOTE,
    //         body: taxDocument,
    //         setFetching: setFetchingCalculateTotalNote
    //     });
    // };


    return {
        fetchingGetPurchaseDocuments,
        fetchingShowPurchaseDocument,
        fetchingStorePurchaseDocument,
        fetchingStoreNote,
        fetchingEditPurchaseDocument,
        fetchingUpdatePurchaseDocument,
        fetchingDeletePurchaseDocument,
        fetchingActivePurchaseDocument,
        fetchingCreatePurchaseDocument,
        fetchingCreateNote,
        fetchingGetPurchaseDocument,
        fetchingDraftPurchaseDocument,
        fetchingAnulledPurchaseDocument,
        fetchingAccountedPurchaseDocument,
        fetchingGetPurchaseDocumentDetails,
        fetchingGetServiceManifestsByClientSociety,
        fetchingGetCauseNote,
        fetchingUpdateNote,
        fetchingCalculateTotalNote,
        getPurchaseDocuments,
        showPurchaseDocument,
        storePurchaseDocument,
        // storeNote,
        createPurchaseDocument,
        // createNote,
        editPurchaseDocument,
        updatePurchaseDocument,
        deletePurchaseDocument,
        activePurchaseDocument,
        // getPurchaseDocument,
        // taxDocumentDraft,
        // taxDocumentAnnulled,
        purchaseDocumentAccounted,
        getPurchaseDocumentDetails,
        getServiceManifestsByClientSociety,
        // getCauseNote,
        // updateNote,
        // calculateTotalNote,
    };
};

export default usePurchaseDocumentService;
